import { IApplicationState } from '../../types/redux';

export function selectWithSeoLinks(state: IApplicationState) {
  return state.showAdditionalSeoLinks;
}
